import {useEffect, useState} from 'react';
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import {confirmAlert} from "react-confirm-alert";

import Alert from "../../../alert/Alert";
import Button from "../../../form/Button";
import Field from "../../Field";
import FormField from "../../../form/Field";
import Loading from "../../../generic/Loading";
import UseGetterNodeValue from "../../hooks/UseGetterNodeValue";
import UseSetterNodeValue from "../../hooks/UseSetterNodeValue";

import {AuthLabel, InfoLabel, SettingsLabel, WebserviceLabel} from "../../../../config/Config";
import {DELETE, GET, PATCH, POST, PUT} from "../../components/Webservice/Methods";
import {API_KEY, BASIC_AUTH, BEARER_TOKEN, NO_AUTH} from "../../components/Webservice/AuthTypes";

const defaultBody = `{
    "origin": "Softtek",
    "channel": "{channel}",
    "id_source": "{id_source}",
    "id_component": "{id_component}",
    "id_journey": "{id_journey}",
    "id_account": "{id_account}",
    "entities": "{entities}"
}`

const defaultHeaders = `{
    "Content-Type": "application/json"
}`

const Webservice = (props) => {
    const {journey, currentNode} = props

    const initialAuthType = UseGetterNodeValue(
        currentNode, 'auth', 'type', NO_AUTH
    )

    const [loading, setLoading] = useState(false)
    const [authType, setAuthType] = useState(initialAuthType.value)


    useEffect(() => {
        if(UseGetterNodeValue(currentNode, 'settings', 'body') === undefined){
            UseSetterNodeValue(currentNode, 'settings', 'body', defaultBody)
        }

        if(UseGetterNodeValue(currentNode, 'settings', 'headers') === undefined){
            UseSetterNodeValue(currentNode, 'settings', 'headers', defaultHeaders)
        }
    }, [authType])


    const handleHeaders = (event) => {
        event.preventDefault()
        handleJson({
            isHeader : true,
            tabName  : 'settings',
            fieldName: 'headers',
            inputName: 'settings[headers]',
        })
    }


    const handleBody = (event) => {
        event.preventDefault()
        handleJson({
            tabName  : 'settings',
            fieldName: 'body',
            inputName: 'settings[body]',
        })
    }





    const handleJson = (props) => {
        const {inputName, tabName, fieldName, isHeader} = props


        const handleFieldChange = (value) => {
            UseSetterNodeValue(currentNode, tabName, fieldName, value)
        }

        const EditorField = {
            name       : inputName,
            tools      : false,
            type       : 'editor',
            language   : 'js',
            label      : `Json ${fieldName}`,
            wrapper    : 'form-group',
            className  : 'form-control',
            overflow   : "auto",
            onChange   : handleFieldChange,
            placeholder: `Paste or type json...`,
            value      : UseGetterNodeValue(currentNode, tabName, fieldName, isHeader ? defaultHeaders : defaultBody),
        };


        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <div className="Window" style={{width: "750px"}}>
                        <div className="WindowHeader">
                            <span className="close" onClick={() => onClose()}>
                            </span>
                        </div>
                        <div className="ModalRules">
                            <div className="JsonEditor">
                                <FormField {...EditorField} />
                            </div>
                            <Button
                                type="button"
                                label="Save changes"
                                className="btn btn-sm btn-primary"
                                onClick={() => onClose()}/>
                        </div>
                    </div>
                )
            }
        });
    }


    return (
        <div>
            {loading && <Loading/>}
            {!loading && <div className="Form">
                <form className="FormComponent" autoComplete="off">
                    <div className="max-width-500">
                        <Alert
                            className="alert-primary"
                            message="Use this component to call a web service."
                            docs={{message: 'For more, please ', path: '/docs/journeys/webservice/'}}
                        />

                        <div className="FieldsetTabs">
                            <Tabs defaultActiveKey="0">
                                <TabPane forceRender={true} key={'tab_settings'} tabKey={'tab_settings'} tab={SettingsLabel}>
                                    <div>
                                        <Field
                                            tab="settings"
                                            name="method"
                                            type="select"
                                            label="Method"
                                            wrapper="form-group"
                                            className="input-sm"
                                            placeholder="Choose one"
                                            classNamePrefix="input-sm"
                                            required={true}
                                            isMulti={false}
                                            isSearchable={true}
                                            options={[GET, PUT, POST, PATCH, DELETE]}
                                            node={currentNode}
                                        />
                                        <Field
                                            tab="settings"
                                            name="endpoint"
                                            type="text"
                                            label="Endpoint"
                                            autoComplete="off"
                                            wrapper="form-group"
                                            required={true}
                                            placeholder="https=//web.services.com/v1/"
                                            node={currentNode}
                                        />
                                        <Alert
                                            className='alert-styles'
                                            message="Use the buttons below to open the header or body editor. "
                                            styles={{
                                                padding     : '10px',
                                                borderRadius: '3px',
                                                background  : '#deeced',
                                                margin      : '16px 0 18px 0',
                                            }}
                                        />

                                        <div className="d-flex">
                                            <button className="btn btn-sm btn-primary me-1" onClick={handleHeaders}>
                                                Set Headers
                                            </button>
                                            <button className="btn btn-sm btn-primary" onClick={handleBody}>
                                                Set Body
                                            </button>
                                        </div>
                                    </div>
                                </TabPane>
                                <TabPane forceRender={true} key={'tab_auth'} tabKey={'tab_auth'} tab={AuthLabel}>
                                    <div>
                                        <Field
                                            tab="auth"
                                            name="type"
                                            type="select"
                                            label="Auth type"
                                            wrapper="form-group"
                                            className="input-sm"
                                            placeholder="Choose one"
                                            classNamePrefix="input-sm"
                                            required={true}
                                            isMulti={false}
                                            isSearchable={true}
                                            options={[NO_AUTH, API_KEY, BEARER_TOKEN, BASIC_AUTH]}
                                            node={currentNode}
                                            defaultValue={authType}
                                            onChange={(selected) => {
                                                setAuthType(selected.value)
                                            }}
                                        />

                                        {authType == BASIC_AUTH.value && <div>
                                            <Field
                                                tab="auth"
                                                name="username"
                                                type="text"
                                                label="Username"
                                                autoComplete="off"
                                                wrapper="form-group"
                                                placeholder="Username"
                                                node={currentNode}
                                                required={true}
                                            />
                                            <Field
                                                tab="auth"
                                                name="password"
                                                type="password"
                                                label="Password"
                                                autoComplete="off"
                                                wrapper="form-group"
                                                placeholder="*******"
                                                node={currentNode}
                                                required={true}
                                            />
                                        </div>}

                                        {authType == API_KEY.value && <div>
                                            <Field
                                                tab="auth"
                                                name="api_key"
                                                type="text"
                                                label="Key"
                                                autoComplete="off"
                                                wrapper="form-group"
                                                placeholder="Api key here..."
                                                node={currentNode}
                                                required={true}
                                            />
                                            <Field
                                                tab="auth"
                                                name="api_value"
                                                type="string"
                                                label="Value"
                                                autoComplete="off"
                                                wrapper="form-group"
                                                placeholder="Api value here..."
                                                node={currentNode}
                                                required={true}
                                            />
                                            <Field
                                                tab="auth"
                                                name="api_append"
                                                type="select"
                                                label="Append to"
                                                wrapper="form-group"
                                                className="input-sm"
                                                placeholder="Choose one"
                                                classNamePrefix="input-sm"
                                                required={true}
                                                isMulti={false}
                                                isSearchable={true}
                                                options={[
                                                    {value: 'header', label: 'Header'},
                                                    {value: 'query', label: 'Query params'}
                                                ]}
                                                node={currentNode}
                                            />
                                        </div>}

                                        {authType == BEARER_TOKEN.value && <div>
                                            <Field
                                                tab="auth"
                                                type="text"
                                                label="Token"
                                                autoComplete="off"
                                                name="bearer_token"
                                                wrapper="form-group"
                                                placeholder="Token here..."
                                                node={currentNode}
                                                required={true}
                                            />
                                        </div>}
                                    </div>
                                </TabPane>
                                <TabPane forceRender={true} key={'tab_info'} tabKey={'tab_info'} tab={InfoLabel}>
                                    <div>
                                        <Field
                                            tab="info"
                                            name="id"
                                            type="text"
                                            label="Component Id"
                                            wrapper="form-group"
                                            disabled={true}
                                            canCopy={true}
                                            defaultValue={currentNode.id}
                                            node={currentNode}
                                        />
                                        <Field
                                            tab="info"
                                            name="title"
                                            type="text"
                                            label="Title"
                                            wrapper="form-group"
                                            placeholder="Type an descriptive title"
                                            node={currentNode}
                                            defaultValue={WebserviceLabel}
                                        />
                                        <Field
                                            tab="info"
                                            name="description"
                                            type="textarea"
                                            label="Description"
                                            wrapper="form-group"
                                            className="form-control"
                                            placeholder="Type a short description"
                                            node={currentNode}
                                        />
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </form>
            </div>}
        </div>
    )
}

export default Webservice;